// Auto-generated lightweight class for VersioningRow
// DO NOT EDIT - Changes will be overwritten

import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { VersioningRowReadAPI, VersioningRowWriteAPI, VersioningRowReadAPISchema, VersioningRowWriteAPISchema } from '../types/versioningrow';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, OfIsland } from '../../relationships/relationship';

import { SecurityScope } from './securityscope';
import { ScopedNode } from './scopednode';



export interface VersioningRow extends Partial<VersioningRowReadAPI> {}
export class VersioningRow extends NeoNodeBase<VersioningRowReadAPI, VersioningRowWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "VersioningRow";
  static readonly readSchema = VersioningRowReadAPISchema;
  static readonly writeSchema = VersioningRowWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    island_root: { target: "ScopedNode", cardinality: "one", isParent: false, relClass: "OfIsland", direction: "out" },
  };

  protected get modelName(): string {
    return 'VersioningRow';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return VersioningRow.label;
  }


  constructor(data: Partial<VersioningRowWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: VersioningRowReadAPI, loadContext?: Record<string, any>): VersioningRow {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { security_scope, island_root, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = VersioningRowReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, security_scope: security_scope, island_root: island_root };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return VersioningRow.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'island_root', 'ScopedNode', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new VersioningRow(processed as any);

    return instance;
  }


  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'island_root' - Python ORM style (cached)
  get island_root(): RelationshipManager<this, ScopedNode> {
    return this.getOrCreateRelationshipManager('island_root', () => {
      return new RelationshipManager(this, 'island_root', 'one', OfIsland as typeof Relationship);
    });
  }

}
